import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { hooks } from '../../config/api';
import Spinner from '../common/spinners/Spinner';
import { SecondaryButton } from '../common/TailwindComponents';
import { ClientDetails } from './components/ClientDetails';
import { EnrollmentApplication } from './components/EnrollmentApplication';
import { EnrollmentConfirmation } from './components/EnrollmentConfirmation';
import { EnrollmentReview } from './components/EnrollmentReview';
import { EnrollmentStepperWrapper } from './components/EnrollmentStepperWrapper';
import { useEnrollmentSteps } from './hooks/useEnrollmentSteps';
export var EnrollmentWorkflow = function EnrollmentWorkflow(_ref) {
  var _data$data$data, _data$data, _plan$name, _formsQuery$data$data, _formsQuery$data;
  var contact = _ref.contact,
    currentEmployee = _ref.currentEmployee,
    fetchRecentUpdates = _ref.fetchRecentUpdates,
    goBackToFacesheet = _ref.goBackToFacesheet,
    groupId = _ref.groupId,
    planId = _ref.planId,
    primaryInsuranceId = _ref.primaryInsuranceId;
  var contactId = contact.id;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    formResponse = _useState2[0],
    setFormResponse = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    attachedDocuments = _useState4[0],
    setAttachedDocuments = _useState4[1];
  var _useEnrollmentSteps = useEnrollmentSteps(),
    step = _useEnrollmentSteps.step,
    goToStep = _useEnrollmentSteps.goToStep,
    stepForward = _useEnrollmentSteps.stepForward,
    stepBackward = _useEnrollmentSteps.stepBackward;
  var _hooks$useFindRecord = hooks.useFindRecord('plan', planId, {
      queryConfig: {
        enabled: !!planId,
        refetchOnWindowFocus: false,
        placeholderData: undefined
      }
    }),
    isLoading = _hooks$useFindRecord.isLoading,
    isFetching = _hooks$useFindRecord.isFetching,
    data = _hooks$useFindRecord.data;
  var formsQuery = hooks.useFind('form', {
    'form_usages.form_utilizer.type': 'plan',
    'form_usages.form_utilizer': planId
  }, {
    api: 'coreApi',
    queryConfig: {
      refetchOnWindowFocus: false
    }
  });
  var plan = (_data$data$data = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) !== null && _data$data$data !== void 0 ? _data$data$data : {};
  var planName = (_plan$name = plan.name) !== null && _plan$name !== void 0 ? _plan$name : '';
  var form = (_formsQuery$data$data = formsQuery === null || formsQuery === void 0 || (_formsQuery$data = formsQuery.data) === null || _formsQuery$data === void 0 || (_formsQuery$data = _formsQuery$data.data) === null || _formsQuery$data === void 0 || (_formsQuery$data = _formsQuery$data.data) === null || _formsQuery$data === void 0 ? void 0 : _formsQuery$data[0]) !== null && _formsQuery$data$data !== void 0 ? _formsQuery$data$data : {};
  var handleFormResponseChange = useCallback(function (responses) {
    setFormResponse(responses);
  }, [setFormResponse]);
  var handleAttachDocuments = useCallback(function (documents) {
    setAttachedDocuments(documents);
  }, [setAttachedDocuments]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryButton, {
    className: "px-4 py-2 bg-white font-regular-font flex items-center text-15px mb-4",
    icon: "IconChevronLeft",
    label: "Back to Client Face Sheet",
    onClick: goBackToFacesheet
  }), isLoading || isFetching ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement("div", {
    className: "border border-solid rounded overflow-hidden divide-y divide-solid divide-med-pale-blue border-dark-pale-blue"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-6 py-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-dark-blue "
  }, "Apply for ", planName, " Enrollment")), /*#__PURE__*/React.createElement("div", {
    className: "bg-white"
  }, step < 3 && /*#__PURE__*/React.createElement("div", {
    className: "p-4 "
  }, /*#__PURE__*/React.createElement(EnrollmentStepperWrapper, {
    step: step,
    goToStep: goToStep
  })), function () {
    switch (step) {
      case 0:
        return /*#__PURE__*/React.createElement(ClientDetails, {
          plan: plan,
          stepForward: stepForward,
          contact: contact,
          contactId: contactId,
          goBackToFacesheet: goBackToFacesheet
        });
      case 1:
        return /*#__PURE__*/React.createElement(EnrollmentApplication, {
          plan: plan,
          form: form,
          formResponse: formResponse,
          handleFormResponseChange: handleFormResponseChange,
          handleAttachDocuments: handleAttachDocuments,
          contactId: contactId,
          stepBackward: stepBackward,
          stepForward: stepForward,
          groupId: groupId,
          currentEmployee: currentEmployee
        });
      case 2:
        return /*#__PURE__*/React.createElement(EnrollmentReview, {
          plan: plan,
          primaryInsuranceId: primaryInsuranceId,
          form: form,
          formResponse: formResponse,
          attachedDocuments: attachedDocuments,
          contactId: contactId,
          stepBackward: stepBackward,
          stepForward: stepForward,
          groupId: groupId,
          currentEmployee: currentEmployee,
          fetchRecentUpdates: fetchRecentUpdates
        });
      case 3:
        return /*#__PURE__*/React.createElement(EnrollmentConfirmation, {
          plan: plan,
          contact: contact,
          goBackToFacesheet: goBackToFacesheet
        });
      default:
        goToStep(0);
        return null;
    }
  }())));
};
EnrollmentWorkflow.propTypes = {
  contact: PropTypes.object.isRequired,
  planId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  currentEmployee: PropTypes.string.isRequired,
  goBackToFacesheet: PropTypes.func.isRequired,
  fetchRecentUpdates: PropTypes.func.isRequired
};
//# sourceMappingURL=EnrollmentWorkflow.js.map